module.exports = __webpack_public_path__ + "static/media/big-neon-sketch-2.44eca1ef.jpg";